const actionTypes = {
    // GET_TOTAL_INVOICE_IN_PROGRESS: 'GET_TOTAL_INVOICE_IN_PROGRESS',
    // GET_LIMIT_INVOICE: 'GET_LIMIT_INVOICE',
    // SET_TOTAL_INVOICE_IN_PROGRESS: 'SET_TOTAL_INVOICE_IN_PROGRESS',
    GET_CURRENT_VALUE_CREDIT: 'GET_CURRENT_VALUE_CREDIT',
    SET_CURRENT_VALUE_CREDIT: 'SET_CURRENT_VALUE_CREDIT',
    GET_CURRENT_BALANCE_CHAIN: 'GET_CURRENT_BALANCE_CHAIN',
    SET_CURRENT_BALANCE_CHAIN: 'SET_CURRENT_BALANCE_CHAIN',
}

export {actionTypes};